/** @format */

import { IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useAppContext } from '../../store/store.app';

function SidebarButton({ sx = {} }) {
  const {
    appStore: { isDrawerOpen },
    ...appCtx
  } = useAppContext();

  return (
    <IconButton
      onClick={appCtx.toggleDrawer}
      variant="outlined"
      size="small"
      color="inherit"
      aria-controls="menu-appbar"
      aria-label="menu"
      sx={[
        {
          marginRight: 2,
        },
        isDrawerOpen && { display: 'none' },
        sx,
      ]}
    >
      <MenuIcon fontSize="small" />
    </IconButton>
  );
}

export default SidebarButton;